import { useState, useEffect, useRef } from "react";

export const useScrollDetector = () => {
  const [scrollYPosition, setScrollYPosition] = useState(0);
  const prevScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.pageYOffset;
      setScrollYPosition(currentScrollY);

      prevScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return { scrollYPosition };
};
